import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import FlowEngine from '../../amsRequest/flowengine';
import ams from '../../common/ams';
var defaultOption = {
  activityId: -1,
  // 活动ID
  gameId: '',
  sData: {} // 以后统一用sData，废弃submitData

};

var getConfig = function getConfig(opt) {
  return new Promise(function (resolve, reject) {
    var iActivityId = opt.iActivityId,
        iFlowId = opt.iFlowId,
        flowConfig = opt.flowConfig;
    ams.amsInit(iActivityId, iFlowId, flowConfig).then(function (_ref) {
      var config = _ref.config;

      var option = _objectSpread(_objectSpread({}, defaultOption), config); // 对参数进行检查


      if (!option.iAMSActivityId) {
        reject({
          errMsg: '抽奖方法未传入活动id'
        });
        return;
      }

      resolve(option);
    })["catch"](function (err) {
      reject(err);
    });
  });
}; // 发送ams请求


var getGiftFunction = function getGiftFunction(option) {
  return new Promise(function (resolve, reject) {
    // if(option.gameId){
    //     if(typeof(GetGiftMain[`_${option.gameId.toUpperCase()}CheckParamResult`]) == 'function'){
    //         const temp_option = GetGiftMain[`_${option.gameId.toUpperCase()}CheckParamResult`](option);
    //         if(!temp_option){
    //             reject();
    //         }
    //         temp_option.activityId = option.activityId;
    //         option = temp_option;
    //     }
    // }
    var iAMSActivityId = option.iAMSActivityId,
        iFlowId = option.iFlowId,
        objCustomMsg = option.objCustomMsg,
        sNeedSubmitPopDiv = option.sNeedSubmitPopDiv; // 使用AMS的提交方式

    var FlowSubmitJson = {
      iActivityId: iAMSActivityId,
      // AMS活动号
      iFlowId: iFlowId,
      sData: option,
      objCustomMsg: objCustomMsg,
      sNeedSubmitPopDiv: sNeedSubmitPopDiv
    };
    FlowEngine.submit(FlowSubmitJson).then(function (res) {
      if (res.iRet == 0) {
        resolve(res);
      } else {
        reject(res);
      }
    })["catch"](function (err) {
      if (err.ret == '600') {
        err.errMsg = '您目前抽奖次数不足，无法进行抽奖';
      }

      reject(err);
    });
  });
};

export default function (opt) {
  return getConfig(opt).then(function (option) {
    var iLotteryFlowId = option.iLotteryFlowId,
        activityId = option.activityId,
        iAMSActivityId = option.iAMSActivityId,
        sNeedSubmitPopDiv = option.sNeedSubmitPopDiv,
        _option$sData = option.sData,
        sData = _option$sData === void 0 ? {} : _option$sData;
    var iFlowId = option.iFlowId || iLotteryFlowId; // 参数设置
    // 填加提交对象

    var submitData = _objectSpread(_objectSpread({}, sData), {}, {
      activityId: activityId,
      iAMSActivityId: iAMSActivityId,
      iFlowId: iFlowId,
      sServiceType: option.gameId || sData.sServiceType || '',
      // 取不到gameId再取sData中的sServiceType
      sNeedSubmitPopDiv: sNeedSubmitPopDiv
    });

    return getGiftFunction(submitData);
  });
}